import React from 'react';
import PropTypes from 'prop-types';

import { ACmsNavigationLink } from '../atoms';

export default function MCmsNavigation({ items, logOut }) {
	const logOutClick = () => {
		logOut();
	};

	return (
		<nav className="m-cms-navigation" >
			<ul>
				{
					items.map(item => <ACmsNavigationLink key={item.title} {...item} />)
				}
				<li className="a-cms-navigation--last-item">
					<button
						onClick={logOutClick}
						className="a-cms-navigation a-cms-navigation--logout-button">
						Log out
					</button>
				</li>
			</ul>

		</nav>
	);
}

MCmsNavigation.propTypes = {
	items: PropTypes.array.isRequired,
	logOut: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.cms-navigation.js